/** @namespace Data */
NS("Data");

Data.Cache = Static({
    values: {},

    cached: function(callback, key, timeout) {
        let val = this.get(key)
        if (val == null) {
            val = callback()
            this.set(key, val, timeout)
        }

        return val
    },

    get (key) {
        return this.values[key]
    },

    set (key, value, ttl) {
        ttl = Util.coalesce(ttl, 3600)

        if (value != null) {
            this.values[key] = value

            setTimeout(() => {
                delete this.values[key]
            }, ttl)
        }

        return this
    }
});
